import React from 'react'
import PropTypes from 'prop-types'

import './AuthLayout.css'
import CompanyLogo from '@/assets/images/aag_logo.webp'
import AppLogo from '@/assets/images/awardsapp_logo.webp'
import LoginImage from '@/assets/images/login_image.webp'

/**
 * Shared layout component for authentication pages
 * Provides consistent structure with logo, content area, and footer
 */
const AuthLayout = ({
    children,
    showImage = false,
    imageText = null,
    className = ''
}) => {
    return (
        <div className={`auth-layout ${showImage ? 'with-image' : ''} ${className}`}>
            <div className="auth-content-container">
                <img
                    src={CompanyLogo}
                    alt="Company Logo"
                    className="company-logo"
                    fetchpriority="high"
                    width="270"
                    height="68"
                />

                <div className="auth-form-wrapper">
                    {children}
                </div>

                <div className="page-footer">
                    <p className="footer-text text-6">
                        <a href="https://www.awards.co.za/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and{' '}
                        <a href="https://www.awards.co.za/terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
                    </p>
                </div>
            </div>

            {showImage && (
                <div
                    className="auth-image-container"
                    style={{ backgroundImage: `url(${LoginImage})` }}
                >
                    <img
                        src={AppLogo}
                        alt="awardsapp Logo"
                        className="awardsapp-logo"
                        fetchpriority="high"
                        width="200"
                        height="36"
                    />

                    {imageText && (
                        <div className="auth-image-text-container">
                            {imageText}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

AuthLayout.propTypes = {
    children: PropTypes.node.isRequired,
    showImage: PropTypes.bool,
    imageText: PropTypes.node,
    className: PropTypes.string,
}

export default AuthLayout
